import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, unref as _unref, resolveComponent as _resolveComponent, withKeys as _withKeys, withCtx as _withCtx, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "d-flex flex-column flex-column-fluid" }
const _hoisted_2 = { class: "d-flex gap-10 justify-content-between" }
const _hoisted_3 = { class: "card" }
const _hoisted_4 = { class: "text-end w-100 mb-4 d-flex align-items-center justify-content-end gap-1 pt-7 pe-7" }
const _hoisted_5 = { class: "d-flex align-items-center" }
const _hoisted_6 = { class: "d-flex align-items-center" }
const _hoisted_7 = { class: "card-body py-4" }
const _hoisted_8 = {
  class: "table align-middle table-row-dashed fs-6 gy-5",
  id: "table_accounts_requests"
}
const _hoisted_9 = { class: "text-start text-muted fw-bold fs-7 text-uppercase gs-0" }
const _hoisted_10 = { key: 0 }
const _hoisted_11 = { class: "text-center min-w-150px" }
const _hoisted_12 = { key: 0 }
const _hoisted_13 = { key: 1 }
const _hoisted_14 = {
  key: 2,
  class: "fw-semibold text-gray-900"
}
const _hoisted_15 = ["onClick"]
const _hoisted_16 = {
  key: 0,
  class: "fa-regular fa-comment-dots text-primary"
}
const _hoisted_17 = {
  key: 1,
  class: "fa-regular fa-comment-dots text-secondary"
}
const _hoisted_18 = { class: "d-flex align-items-center" }
const _hoisted_19 = { key: 0 }
const _hoisted_20 = { class: "text-center" }
const _hoisted_21 = ["onClick"]

import { ref, onMounted, watch, inject, provide } from "vue";
import TableFooter from "@/components/TableFooter.vue";
import {
  VerificationStatusTypes,
  VerificationStatus,
} from "@/core/types/VerificationInfos";
import UserService from "../../services/UserService";
import MsgPrompt from "@/core/plugins/MsgPrompt";
import UserVerifyDocModal from "@/projects/tenant/modules/accounts/components/modal/UserVerifyDocModal.vue";
import { Search, WarningFilled, Avatar } from "@element-plus/icons-vue";
import InjectKeys from "@/core/types/TenantGlobalInjectionKeys";
import CommentsView from "@/projects/tenant/components/CommentView.vue";
import { CommentType } from "@/core/types/CommentType";
import CommonTabs from "@/projects/tenant/components/CommonTabs.vue";
import { useI18n } from "vue-i18n";


export default /*#__PURE__*/_defineComponent({
  __name: 'bviVerification',
  setup(__props) {

const { t } = useI18n();
const userVerifyDocModal = ref<InstanceType<typeof UserVerifyDocModal>>();
const isLoading = ref(true);
const items = ref(Array<any>());
const tab = ref(VerificationStatusTypes.AwaitingReview);
// 74f9f9d
const criteria = ref({
  page: 1,
  size: 10,
  status: tab.value,
  sortField: "UpdatedOn",
});

const tabsData = [
  {
    index: 0,
    label: t("status.pending"),
    status: VerificationStatusTypes.AwaitingReview,
  },
  {
    index: 1,
    label: t("status.reviewing"),
    status: VerificationStatusTypes.UnderReview,
  },
  {
    index: 2,
    label: t("status.reviewed"),
    status: VerificationStatusTypes.AwaitingApprove,
  },
  {
    index: 3,
    label: t("status.approved"),
    status: VerificationStatusTypes.Approved,
  },
  {
    index: 4,
    label: t("status.rejected"),
    status: VerificationStatusTypes.Rejected,
  },
  {
    index: 5,
    label: t("status.incomplete"),
    status: VerificationStatusTypes.Incomplete,
  },
  {
    index: 6,
    label: t("status.all"),
    status: null,
  },
];

const openCommentView = inject<
  (type: CommentType, id: number, title: string) => any
>(InjectKeys.OPEN_COMMENT_VIEW, () => null);

const reset = () => {
  criteria.value.email = null;
  fetchData(1);
};

const search = () => {
  criteria.value.status = null;
  fetchData(1);
};
// on mounted, fetch the first page of Awaiting verification users
onMounted(() => {
  fetchData(1);
});

const fetchData = async (selectedPage: number) => {
  criteria.value.page = selectedPage;
  isLoading.value = true;
  try {
    const res = await UserService.queryVerifications(criteria.value);
    items.value = res.data.map((x) => ({
      ...x,
      user: { ...x.user, partyId: x.partyId },
    }));
    criteria.value = res.criteria;
  } catch (error) {
    MsgPrompt.error(error);
  } finally {
    isLoading.value = false;
  }
};

provide("criteria", criteria);
provide("isLoading", isLoading);
provide("tabsData", tabsData);
provide("fetchData", fetchData);

const onVerificationFinished = async () => {
  await fetchData(1);
  userVerifyDocModal.value?.hide();
};

watch(
  () => criteria.value.status,
  () => fetchData(1)
);

// const pageChange = (page: number) => {
//   fetchData(page);
// };

return (_ctx: any,_cache: any) => {
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_icon = _resolveComponent("el-icon")!
  const _component_LoadingRing = _resolveComponent("LoadingRing")!
  const _component_NoDataBox = _resolveComponent("NoDataBox")!
  const _component_UserInfo = _resolveComponent("UserInfo")!
  const _component_TimeShow = _resolveComponent("TimeShow")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createVNode(CommonTabs),
        _createElementVNode("div", null, [
          _createVNode(_component_el_input, {
            class: "w-400px",
            modelValue: criteria.value.searchText,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((criteria.value.searchText) = $event)),
            onKeyup: _withKeys(search, ["enter"]),
            clearable: true,
            placeholder: "Search Key Words"
          }, {
            append: _withCtx(() => [
              _createVNode(_component_el_button, {
                icon: _unref(Search),
                onClick: search
              }, null, 8, ["icon"])
            ]),
            _: 1
          }, 8, ["modelValue", "onKeyup"]),
          _createVNode(_component_el_button, {
            class: "ms-4",
            type: "info",
            plain: "",
            onClick: reset
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$t("action.reset")), 1)
            ]),
            _: 1
          })
        ])
      ]),
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createVNode(_component_el_icon, { color: "#FF0000" }, {
              default: _withCtx(() => [
                _createVNode(_unref(WarningFilled))
              ]),
              _: 1
            }),
            _createTextVNode(" " + _toDisplayString(_ctx.$t("title.cheaterIp")) + " | ", 1)
          ]),
          _createElementVNode("div", _hoisted_6, [
            _createVNode(_component_el_icon, null, {
              default: _withCtx(() => [
                _createVNode(_unref(Avatar))
              ]),
              _: 1
            }),
            _createTextVNode(" " + _toDisplayString(_ctx.$t("status.blocked")), 1)
          ])
        ]),
        _createElementVNode("div", _hoisted_7, [
          _createElementVNode("table", _hoisted_8, [
            _createElementVNode("thead", null, [
              _createElementVNode("tr", _hoisted_9, [
                _createElementVNode("th", null, _toDisplayString(_ctx.$t("fields.verificationId")), 1),
                _createElementVNode("th", null, _toDisplayString(_ctx.$t("fields.client")), 1),
                _createElementVNode("th", null, _toDisplayString(_ctx.$t("fields.status")), 1),
                _createElementVNode("th", null, _toDisplayString(_ctx.$t("fields.updatedOn")), 1),
                (
                  criteria.value.status === _unref(VerificationStatusTypes).Approved ||
                  criteria.value.status == null
                )
                  ? (_openBlock(), _createElementBlock("th", _hoisted_10, _toDisplayString(_ctx.$t("fields.operator")), 1))
                  : _createCommentVNode("", true),
                _createElementVNode("th", _hoisted_11, _toDisplayString(_ctx.$t("action.action")), 1)
              ])
            ]),
            (isLoading.value)
              ? (_openBlock(), _createElementBlock("tbody", _hoisted_12, [
                  _createVNode(_component_LoadingRing)
                ]))
              : (!isLoading.value && items.value.length === 0)
                ? (_openBlock(), _createElementBlock("tbody", _hoisted_13, [
                    _createVNode(_component_NoDataBox)
                  ]))
                : (_openBlock(), _createElementBlock("tbody", _hoisted_14, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(items.value, (item, index) => {
                      return (_openBlock(), _createElementBlock("tr", { key: index }, [
                        _createElementVNode("td", null, [
                          _createTextVNode(_toDisplayString(item.id) + " ", 1),
                          (_ctx.$can('Admin'))
                            ? (_openBlock(), _createElementBlock("span", {
                                key: 0,
                                class: "ms-2 cursor-pointer",
                                role: "button",
                                onClick: ($event: any) => (
                    _unref(openCommentView)(
                      _unref(CommentType).Verification,
                      item.id,
                      item.user?.firstName + ' ' + item.user?.lastName
                    )
                  )
                              }, [
                                (item.hasComment)
                                  ? (_openBlock(), _createElementBlock("i", _hoisted_16))
                                  : (_openBlock(), _createElementBlock("i", _hoisted_17)),
                                (item.user.isInIpBlackList)
                                  ? (_openBlock(), _createBlock(_component_el_icon, {
                                      key: 2,
                                      class: "ms-1",
                                      color: "#FF0000"
                                    }, {
                                      default: _withCtx(() => [
                                        _createVNode(_unref(WarningFilled))
                                      ]),
                                      _: 1
                                    }))
                                  : _createCommentVNode("", true),
                                (item.user.isInUserBlackList)
                                  ? (_openBlock(), _createBlock(_component_el_icon, {
                                      key: 3,
                                      class: "ms-1"
                                    }, {
                                      default: _withCtx(() => [
                                        _createVNode(_unref(Avatar))
                                      ]),
                                      _: 1
                                    }))
                                  : _createCommentVNode("", true)
                              ], 8, _hoisted_15))
                            : _createCommentVNode("", true)
                        ]),
                        _createElementVNode("td", _hoisted_18, [
                          _createVNode(_component_UserInfo, {
                            user: item.user,
                            class: "me-2"
                          }, null, 8, ["user"])
                        ]),
                        _createElementVNode("td", null, _toDisplayString(_ctx.$t(`status.${_unref(VerificationStatus)[item.status]}`)), 1),
                        _createElementVNode("td", null, [
                          _createVNode(_component_TimeShow, {
                            "date-iso-string": item.updatedOn
                          }, null, 8, ["date-iso-string"])
                        ]),
                        (
                  criteria.value.status == null ||
                  item.status === _unref(VerificationStatusTypes).Approved
                )
                          ? (_openBlock(), _createElementBlock("td", _hoisted_19, [
                              (item.operator)
                                ? (_openBlock(), _createBlock(_component_UserInfo, {
                                    key: 0,
                                    user: item.operator,
                                    disableCommentView: "true"
                                  }, null, 8, ["user"]))
                                : _createCommentVNode("", true)
                            ]))
                          : _createCommentVNode("", true),
                        _createElementVNode("td", _hoisted_20, [
                          (item.status != _unref(VerificationStatusTypes).Incomplete)
                            ? (_openBlock(), _createElementBlock("button", {
                                key: 0,
                                class: "btn btn-light btn-primary btn-sm me-3",
                                onClick: ($event: any) => (userVerifyDocModal.value?.show(item.id))
                              }, _toDisplayString(_ctx.$t("action.details")), 9, _hoisted_21))
                            : _createCommentVNode("", true)
                        ])
                      ]))
                    }), 128))
                  ]))
          ]),
          _createVNode(TableFooter, {
            onPageChange: fetchData,
            criteria: criteria.value
          }, null, 8, ["criteria"])
        ])
      ])
    ]),
    _createVNode(UserVerifyDocModal, {
      ref_key: "userVerifyDocModal",
      ref: userVerifyDocModal,
      onUserApproved: onVerificationFinished,
      onUserMoved: _cache[1] || (_cache[1] = ($event: any) => (fetchData(1)))
    }, null, 512)
  ], 64))
}
}

})